<template>
    <div v-if="visible" class="loading"> 
        <div v-if="type === 'modern'">
            <div class="moderns">
                <div class="modern"></div>
                <div class="modern"></div>
                <div class="modern"></div>
                <div class="modern"></div>
                <div class="modern"></div>
            </div>

            <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <filter id="goo">
                        <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="12" ></feGaussianBlur>
                        <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0	0 1 0 0 0	0 0 1 0 0	0 0 0 18 -7" result="goo" ></feColorMatrix>
                        <!--<feBlend in2="goo" in="SourceGraphic" result="mix" ></feBlend>-->
                    </filter>
                </defs>
            </svg>
        </div>
        <div class="spinner" v-if="type === 'dynamic'">
            <div class="dynamic">
                <span id="dynamic_1">
                </span>
                <span id="dynamic_2">
                </span>
                <span id="dynamic_3">
                </span>
            </div>
        </div> 
        <div class="spinner" v-if="type === 'classic'">
            <div class="classic">
                <div class="wBall" id="wBall_1">
                    <div class="wInnerBall"></div>
                </div>
                <div class="wBall" id="wBall_2">
                    <div class="wInnerBall"></div>
                </div>
                <div class="wBall" id="wBall_3">
                    <div class="wInnerBall"></div>
                </div>
                <div class="wBall" id="wBall_4">
                    <div class="wInnerBall"></div>
                </div>
                <div class="wBall" id="wBall_5">
                    <div class="wInnerBall"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Spinner',
    props: {
        type:{
			type: String,
            required: false,
            default: () => 'modern'
		},	
        visible: {
			type: Boolean,
            required: false,
            default: () => true
		},	
    }
}
</script>


<style>
.loading {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: 2;
    background-color: rgba(255, 255, 255, 0.5);
}

.spinner {    	
    position: relative;
    top: 46%;
    margin: auto;
}

.classic {
	position: relative;
	width: 78px;
	height:78px;
	margin:auto;
}

.classic .wBall {
	position: absolute;
	width: 74px;
	height: 74px;
	opacity: 0;
	transform: rotate(225deg);
		-o-transform: rotate(225deg);
		-ms-transform: rotate(225deg);
		-webkit-transform: rotate(225deg);
		-moz-transform: rotate(225deg);
	animation: orbit 6.96s infinite;
		-o-animation: orbit 6.96s infinite;
		-ms-animation: orbit 6.96s infinite;
		-webkit-animation: orbit 6.96s infinite;
		-moz-animation: orbit 6.96s infinite;
}

.classic .wBall .wInnerBall{
	position: absolute;
	width: 10px;
	height: 10px;
	background: rgb(127,194,65);
	left:0px;
	top:0px;
	border-radius: 10px;
}

.classic #wBall_1 {
	animation-delay: 1.52s;
		-o-animation-delay: 1.52s;
		-ms-animation-delay: 1.52s;
		-webkit-animation-delay: 1.52s;
		-moz-animation-delay: 1.52s;
}

.classic #wBall_2 {
	animation-delay: 0.3s;
		-o-animation-delay: 0.3s;
		-ms-animation-delay: 0.3s;
		-webkit-animation-delay: 0.3s;
		-moz-animation-delay: 0.3s;
}

.classic #wBall_3 {
	animation-delay: 0.61s;
		-o-animation-delay: 0.61s;
		-ms-animation-delay: 0.61s;
		-webkit-animation-delay: 0.61s;
		-moz-animation-delay: 0.61s;
}

.classic #wBall_4 {
	animation-delay: 0.91s;
		-o-animation-delay: 0.91s;
		-ms-animation-delay: 0.91s;
		-webkit-animation-delay: 0.91s;
		-moz-animation-delay: 0.91s;
}

.classic #wBall_5 {
	animation-delay: 1.22s;
		-o-animation-delay: 1.22s;
		-ms-animation-delay: 1.22s;
		-webkit-animation-delay: 1.22s;
		-moz-animation-delay: 1.22s;
}



@keyframes orbit {
	0% {
		opacity: 1;
		z-index:99;
		transform: rotate(180deg);
		animation-timing-function: ease-out;
	}

	7% {
		opacity: 1;
		transform: rotate(300deg);
		animation-timing-function: linear;
		origin:0%;
	}

	30% {
		opacity: 1;
		transform:rotate(410deg);
		animation-timing-function: ease-in-out;
		origin:7%;
	}

	39% {
		opacity: 1;
		transform: rotate(645deg);
		animation-timing-function: linear;
		origin:30%;
	}

	70% {
		opacity: 1;
		transform: rotate(770deg);
		animation-timing-function: ease-out;
		origin:39%;
	}

	75% {
		opacity: 1;
		transform: rotate(900deg);
		animation-timing-function: ease-out;
		origin:70%;
	}

	76% {
	opacity: 0;
		transform:rotate(900deg);
	}

	100% {
	opacity: 0;
		transform: rotate(900deg);
	}
}

@-o-keyframes orbit {
	0% {
		opacity: 1;
		z-index:99;
		-o-transform: rotate(180deg);
		-o-animation-timing-function: ease-out;
	}

	7% {
		opacity: 1;
		-o-transform: rotate(300deg);
		-o-animation-timing-function: linear;
		-o-origin:0%;
	}

	30% {
		opacity: 1;
		-o-transform:rotate(410deg);
		-o-animation-timing-function: ease-in-out;
		-o-origin:7%;
	}

	39% {
		opacity: 1;
		-o-transform: rotate(645deg);
		-o-animation-timing-function: linear;
		-o-origin:30%;
	}

	70% {
		opacity: 1;
		-o-transform: rotate(770deg);
		-o-animation-timing-function: ease-out;
		-o-origin:39%;
	}

	75% {
		opacity: 1;
		-o-transform: rotate(900deg);
		-o-animation-timing-function: ease-out;
		-o-origin:70%;
	}

	76% {
	opacity: 0;
		-o-transform:rotate(900deg);
	}

	100% {
	opacity: 0;
		-o-transform: rotate(900deg);
	}
}

@-ms-keyframes orbit {
	0% {
		opacity: 1;
		z-index:99;
		-ms-transform: rotate(180deg);
		-ms-animation-timing-function: ease-out;
	}

	7% {
		opacity: 1;
		-ms-transform: rotate(300deg);
		-ms-animation-timing-function: linear;
		-ms-origin:0%;
	}

	30% {
		opacity: 1;
		-ms-transform:rotate(410deg);
		-ms-animation-timing-function: ease-in-out;
		-ms-origin:7%;
	}

	39% {
		opacity: 1;
		-ms-transform: rotate(645deg);
		-ms-animation-timing-function: linear;
		-ms-origin:30%;
	}

	70% {
		opacity: 1;
		-ms-transform: rotate(770deg);
		-ms-animation-timing-function: ease-out;
		-ms-origin:39%;
	}

	75% {
		opacity: 1;
		-ms-transform: rotate(900deg);
		-ms-animation-timing-function: ease-out;
		-ms-origin:70%;
	}

	76% {
	opacity: 0;
		-ms-transform:rotate(900deg);
	}

	100% {
	opacity: 0;
		-ms-transform: rotate(900deg);
	}
}

@-webkit-keyframes orbit {
	0% {
		opacity: 1;
		z-index:99;
		-webkit-transform: rotate(180deg);
		-webkit-animation-timing-function: ease-out;
	}

	7% {
		opacity: 1;
		-webkit-transform: rotate(300deg);
		-webkit-animation-timing-function: linear;
		-webkit-origin:0%;
	}

	30% {
		opacity: 1;
		-webkit-transform:rotate(410deg);
		-webkit-animation-timing-function: ease-in-out;
		-webkit-origin:7%;
	}

	39% {
		opacity: 1;
		-webkit-transform: rotate(645deg);
		-webkit-animation-timing-function: linear;
		-webkit-origin:30%;
	}

	70% {
		opacity: 1;
		-webkit-transform: rotate(770deg);
		-webkit-animation-timing-function: ease-out;
		-webkit-origin:39%;
	}

	75% {
		opacity: 1;
		-webkit-transform: rotate(900deg);
		-webkit-animation-timing-function: ease-out;
		-webkit-origin:70%;
	}

	76% {
	opacity: 0;
		-webkit-transform:rotate(900deg);
	}

	100% {
	opacity: 0;
		-webkit-transform: rotate(900deg);
	}
}

@-moz-keyframes orbit {
	0% {
		opacity: 1;
		z-index:99;
		-moz-transform: rotate(180deg);
		-moz-animation-timing-function: ease-out;
	}

	7% {
		opacity: 1;
		-moz-transform: rotate(300deg);
		-moz-animation-timing-function: linear;
		-moz-origin:0%;
	}

	30% {
		opacity: 1;
		-moz-transform:rotate(410deg);
		-moz-animation-timing-function: ease-in-out;
		-moz-origin:7%;
	}

	39% {
		opacity: 1;
		-moz-transform: rotate(645deg);
		-moz-animation-timing-function: linear;
		-moz-origin:30%;
	}

	70% {
		opacity: 1;
		-moz-transform: rotate(770deg);
		-moz-animation-timing-function: ease-out;
		-moz-origin:39%;
	}

	75% {
		opacity: 1;
		-moz-transform: rotate(900deg);
		-moz-animation-timing-function: ease-out;
		-moz-origin:70%;
	}

	76% {
	opacity: 0;
		-moz-transform:rotate(900deg);
	}

	100% {
	opacity: 0;
		-moz-transform: rotate(900deg);
	}
}


.dynamic {
	text-align: center;
	width:78px;
	height:49px;
	margin: auto;
}

.dynamic span {
	display: inline-block;
	vertical-align: middle;
	width: 10px;
	height: 10px;
	margin: 24px auto;
	background: rgb(0,122,94);
	border-radius: 49px;
		-o-border-radius: 49px;
		-ms-border-radius: 49px;
		-webkit-border-radius: 49px;
		-moz-border-radius: 49px;
	animation: dynamic 1.5s infinite alternate;
		-o-animation: dynamic 1.5s infinite alternate;
		-ms-animation: dynamic 1.5s infinite alternate;
		-webkit-animation: dynamic 1.5s infinite alternate;
		-moz-animation: dynamic 1.5s infinite alternate;
}

#dynamic_1 {
	animation-delay: 0s;
		-o-animation-delay: 0s;
		-ms-animation-delay: 0s;
		-webkit-animation-delay: 0s;
		-moz-animation-delay: 0s;
}

#dynamic_2 {
	animation-delay: 0.45s;
		-o-animation-delay: 0.45s;
		-ms-animation-delay: 0.45s;
		-webkit-animation-delay: 0.45s;
		-moz-animation-delay: 0.45s;
}

#dynamic_3 {
	animation-delay: 0.9s;
		-o-animation-delay: 0.9s;
		-ms-animation-delay: 0.9s;
		-webkit-animation-delay: 0.9s;
		-moz-animation-delay: 0.9s;
}



@keyframes dynamic {
	0% {
		width: 10px;
		height: 10px;
		background-color:rgb(127,194,65);
		transform: translateY(0);
	}

	100% {
		width: 23px;
		height: 23px;
		background-color:rgb(255,255,255);
		transform: translateY(-20px);
	}
}

@-o-keyframes dynamic {
	0% {
		width: 10px;
		height: 10px;
		background-color:rgb(127,194,65);
		-o-transform: translateY(0);
	}

	100% {
		width: 23px;
		height: 23px;
		background-color:rgb(255,255,255);
		-o-transform: translateY(-20px);
	}
}

@-ms-keyframes dynamic {
	0% {
		width: 10px;
		height: 10px;
		background-color:rgb(127,194,65);
		-ms-transform: translateY(0);
	}

	100% {
		width: 23px;
		height: 23px;
		background-color:rgb(255,255,255);
		-ms-transform: translateY(-20px);
	}
}

@-webkit-keyframes dynamic {
	0% {
		width: 10px;
		height: 10px;
		background-color:rgb(127,194,65);
		-webkit-transform: translateY(0);
	}

	100% {
		width: 23px;
		height: 23px;
		background-color:rgb(255,255,255);
		-webkit-transform: translateY(-20px);
	}
}

@-moz-keyframes dynamic {
	0% {
		width: 10px;
		height: 10px;
		background-color:rgb(127,194,65);
		-moz-transform: translateY(0);
	}

	100% {
		width: 23px;
		height: 23px;
		background-color:rgb(255,255,255);
		-moz-transform: translateY(-20px);
	}
}



.moderns {
	width: 0;
	height: 0;
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	margin: auto;
	outline: 1px solid red;
	filter: url(#goo);
		-o-filter: 		url(#goo);
		-ms-filter: 	url(#goo);
		-webkit-filter: url(#goo);
		-moz-filter: 	url(#goo);
}

.modern {
	width: 30px;
	height: 85px;
	position: absolute;
	left: 0;
	top: 0;
}
.modern:before {
	content: "";
	width: 31px;
	height: 31px;
	border-radius: 45px;
	background: rgb(241,175,22);
	position: absolute;
	left: 50%;
	transform: translateY(0);
		-o-transform: translateY(0);
		-ms-transform: translateY(0);
		-webkit-transform: translateY(0);
		-moz-transform: translateY(0);
	margin-left: -15.5px;
	margin-top: -15.5px;
}



.modern:nth-child(5):before {
	z-index: 100;
	width: 40.5px;
	height: 40.5px;
	margin-left: -20.75px;
	margin-top: -20.75px;
	animation: modern-colors 4s ease infinite;
		-o-animation: modern-colors 4s ease infinite;
		-ms-animation: modern-colors 4s ease infinite;
		-webkit-animation: modern-colors 4s ease infinite;
		-moz-animation: modern-colors 4s ease infinite;
}


.modern:nth-child(1) {
	animation: modern-rotate-1 4s 0s linear infinite;
		-o-animation: modern-rotate-1 4s 0s linear infinite;
		-ms-animation: modern-rotate-1 4s 0s linear infinite;
		-webkit-animation: modern-rotate-1 4s 0s linear infinite;
		-moz-animation: modern-rotate-1 4s 0s linear infinite;
}
.modern:nth-child(1):before {
	background-color: rgb(246,138,30);
	animation: modern-move 4s 0s ease infinite;
		-o-animation: modern-move 4s 0s ease infinite;
		-ms-animation: modern-move 4s 0s ease infinite;
		-webkit-animation: modern-move 4s 0s ease infinite;
		-moz-animation: modern-move 4s 0s ease infinite;
}

.modern:nth-child(2) {
	animation: modern-rotate-2 4s 1s linear infinite;
		-o-animation: modern-rotate-2 4s 1s linear infinite;
		-ms-animation: modern-rotate-2 4s 1s linear infinite;
		-webkit-animation: modern-rotate-2 4s 1s linear infinite;
		-moz-animation: modern-rotate-2 4s 1s linear infinite;
}
.modern:nth-child(2):before {
	background-color: rgb(0,122,94);
	animation: modern-move 4s 1s ease infinite;
		-o-animation: modern-move 4s 1s ease infinite;
		-ms-animation: modern-move 4s 1s ease infinite;
		-webkit-animation: modern-move 4s 1s ease infinite;
		-moz-animation: modern-move 4s 1s ease infinite;
}

.modern:nth-child(3) {
	animation: modern-rotate-3 4s 2s linear infinite;
		-o-animation: modern-rotate-3 4s 2s linear infinite;
		-ms-animation: modern-rotate-3 4s 2s linear infinite;
		-webkit-animation: modern-rotate-3 4s 2s linear infinite;
		-moz-animation: modern-rotate-3 4s 2s linear infinite;
}
.modern:nth-child(3):before {
	background-color: rgb(127,194,65);
	animation: modern-move 4s 2s ease infinite;
		-o-animation: modern-move 4s 2s ease infinite;
		-ms-animation: modern-move 4s 2s ease infinite;
		-webkit-animation: modern-move 4s 2s ease infinite;
		-moz-animation: modern-move 4s 2s ease infinite;
}

.modern:nth-child(4) {
	animation: modern-rotate-4 4s 3s linear infinite;
		-o-animation: modern-rotate-4 4s 3s linear infinite;
		-ms-animation: modern-rotate-4 4s 3s linear infinite;
		-webkit-animation: modern-rotate-4 4s 3s linear infinite;
		-moz-animation: modern-rotate-4 4s 3s linear infinite;
}
.modern:nth-child(4):before {
	background-color: rgb(241,175,22);
	animation: modern-move 4s 3s ease infinite;
		-o-animation: modern-move 4s 3s ease infinite;
		-ms-animation: modern-move 4s 3s ease infinite;
		-webkit-animation: modern-move 4s 3s ease infinite;
		-moz-animation: modern-move 4s 3s ease infinite;
}

@keyframes modern-move {
	0% {
		transform: translateY(0);
	}
	18%, 22% {
		transform: translateY(-63px);
	}
	40%, 100% {
		transform: translateY(0);
	}
}

@-o-keyframes modern-move {
	0% {
		-o-transform: translateY(0);
	}
	18%, 22% {
		-o-transform: translateY(-63px);
	}
	40%, 100% {
		-o-transform: translateY(0);
	}
}

@-ms-keyframes modern-move {
	0% {
		-ms-transform: translateY(0);
	}
	18%, 22% {
		-ms-transform: translateY(-63px);
	}
	40%, 100% {
		-ms-transform: translateY(0);
	}
}

@-webkit-keyframes modern-move {
	0% {
		-webkit-transform: translateY(0);
	}
	18%, 22% {
		-webkit-transform: translateY(-63px);
	}
	40%, 100% {
		-webkit-transform: translateY(0);
	}
}

@-moz-keyframes modern-move {
	0% {
		-moz-transform: translateY(0);
	}
	18%, 22% {
		-moz-transform: translateY(-63px);
	}
	40%, 100% {
		-moz-transform: translateY(0);
	}
}

@keyframes modern-colors {
	0% {
		background-color: rgb(241,175,22);
	}
	25% {
		background-color: rgb(246,138,30);
	}
	50% {
		background-color: rgb(0,122,94);
	}
	75% {
		background-color: rgb(127,194,65);
	}
	100% {
		background-color: rgb(241,175,22);
	}
}

@-o-keyframes modern-colors {
	0% {
		background-color: rgb(241,175,22);
	}
	25% {
		background-color: rgb(246,138,30);
	}
	50% {
		background-color: rgb(0,122,94);
	}
	75% {
		background-color: rgb(127,194,65);
	}
	100% {
		background-color: rgb(241,175,22);
	}
}

@-ms-keyframes modern-colors {
	0% {
		background-color: rgb(241,175,22);
	}
	25% {
		background-color: rgb(246,138,30);
	}
	50% {
		background-color: rgb(0,122,94);
	}
	75% {
		background-color: rgb(127,194,65);
	}
	100% {
		background-color: rgb(241,175,22);
	}
}

@-webkit-keyframes modern-colors {
	0% {
		background-color: rgb(241,175,22);
	}
	25% {
		background-color: rgb(246,138,30);
	}
	50% {
		background-color: rgb(0,122,94);
	}
	75% {
		background-color: rgb(127,194,65);
	}
	100% {
		background-color: rgb(241,175,22);
	}
}

@-moz-keyframes modern-colors {
	0% {
		background-color: rgb(241,175,22);
	}
	25% {
		background-color: rgb(246,138,30);
	}
	50% {
		background-color: rgb(0,122,94);
	}
	75% {
		background-color: rgb(127,194,65);
	}
	100% {
		background-color: rgb(241,175,22);
	}
}

@keyframes modern-rotate-1 {
	0% {
		transform: rotate(-105deg);
	}
	100% {
		transform: rotate(270deg);
	}
}

@-o-keyframes modern-rotate-1 {
	0% {
		-o-transform: rotate(-105deg);
	}
	100% {
		-o-transform: rotate(270deg);
	}
}

@-ms-keyframes modern-rotate-1 {
	0% {
		-ms-transform: rotate(-105deg);
	}
	100% {
		-ms-transform: rotate(270deg);
	}
}

@-webkit-keyframes modern-rotate-1 {
	0% {
		-webkit-transform: rotate(-105deg);
	}
	100% {
		-webkit-transform: rotate(270deg);
	}
}

@-moz-keyframes modern-rotate-1 {
	0% {
		-moz-transform: rotate(-105deg);
	}
	100% {
		-moz-transform: rotate(270deg);
	}
}

@keyframes modern-rotate-2 {
	0% {
		transform: rotate(165deg);
	}
	100% {
		transform: rotate(540deg);
	}
}

@-o-keyframes modern-rotate-2 {
	0% {
		-o-transform: rotate(165deg);
	}
	100% {
		-o-transform: rotate(540deg);
	}
}

@-ms-keyframes modern-rotate-2 {
	0% {
		-ms-transform: rotate(165deg);
	}
	100% {
		-ms-transform: rotate(540deg);
	}
}

@-webkit-keyframes modern-rotate-2 {
	0% {
		-webkit-transform: rotate(165deg);
	}
	100% {
		-webkit-transform: rotate(540deg);
	}
}

@-moz-keyframes modern-rotate-2 {
	0% {
		-moz-transform: rotate(165deg);
	}
	100% {
		-moz-transform: rotate(540deg);
	}
}

@keyframes modern-rotate-3 {
	0% {
		transform: rotate(435deg);
	}
	100% {
		transform: rotate(810deg);
	}
}

@-o-keyframes modern-rotate-3 {
	0% {
		-o-transform: rotate(435deg);
	}
	100% {
		-o-transform: rotate(810deg);
	}
}

@-ms-keyframes modern-rotate-3 {
	0% {
		-ms-transform: rotate(435deg);
	}
	100% {
		-ms-transform: rotate(810deg);
	}
}

@-webkit-keyframes modern-rotate-3 {
	0% {
		-webkit-transform: rotate(435deg);
	}
	100% {
		-webkit-transform: rotate(810deg);
	}
}

@-moz-keyframes modern-rotate-3 {
	0% {
		-moz-transform: rotate(435deg);
	}
	100% {
		-moz-transform: rotate(810deg);
	}
}

@keyframes modern-rotate-4 {
	0% {
		transform: rotate(705deg);
	}
	100% {
		transform: rotate(1080deg);
	}
}

@-o-keyframes modern-rotate-4 {
	0% {
		-o-transform: rotate(705deg);
	}
	100% {
		-o-transform: rotate(1080deg);
	}
}

@-ms-keyframes modern-rotate-4 {
	0% {
		-ms-transform: rotate(705deg);
	}
	100% {
		-ms-transform: rotate(1080deg);
	}
}

@-webkit-keyframes modern-rotate-4 {
	0% {
		-webkit-transform: rotate(705deg);
	}
	100% {
		-webkit-transform: rotate(1080deg);
	}
}

@-moz-keyframes modern-rotate-4 {
	0% {
		-moz-transform: rotate(705deg);
	}
	100% {
		-moz-transform: rotate(1080deg);
	}
}
</style>

